import common from '@page/common/js/common';
import $ from 'jquery';

import useGlobalLayout from '@global/composable/useGlobalLayout';
import useFreeLayout from '@global/composable/useFreeLayout';

require('@global/vendors/slick');

const { globalLayout } = useGlobalLayout();
const { initSlick, transitionEffects } = useFreeLayout();

globalLayout({
  banner: {
    isopen: true,
    opts: {
      dots: true,
      arrows: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 5000,
    },
    squareOpts: {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      speed: 800,
      responsive: [
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            dots: false,
          },
        },
      ],
    },
    fullbanner: {
      play: 5000,
    },
  },
  popupOpen: true,
  popupShowOnce: true,
});

setTimeout(() => {
  $('#page-home').css('opacity', '1');
}, 100);

$(document).ready(() => {
  const $header = $('#page-home .header');
  const headerHight = $header.height();

  if ($header.length < 1) return;

  $(window).on('scroll', () => {
    $(window).scrollTop() > headerHight
      ? $header.addClass('active')
      : $header.removeClass('active');
  });

  if (window.PictureContainer !== 'moonmoonfood') {
    $('#page-home .logo-image').addClass('logo-filter');
  }
});

initSlick();
transitionEffects();
